<template>
    <div class="pdf-print-navbar">
        <span class="navbar-row-top">
            <div class="image-box">
                <img class="logo" src="@/assets/checklist-app.jpeg" alt="">
            </div>
        </span>
        <div class="navbar-row-bottom">
            <div v-if="craft" class="nav-column" >
                <span class="keyName">{{trans(path_title)}}</span>
                <span class="keyValue">{{current_visit}} / {{trans(craft)}}</span>
            </div>
            <div v-else-if="current_visit" class="nav-column" >
                <span class="keyName">{{trans(path_title)}}</span>
                <span class="keyValue">{{current_visit}}</span>
            </div>
            <div v-if="betreiber" class="nav-column">
                <span class="keyName">{{trans('Betreiber')}}</span>
                <span class="keyValue">{{betreiber}}</span>
            </div>
            <div v-else-if="org" class="nav-column">
                <span class="keyName">{{trans('firma')}}</span>
                <span class="keyValue">{{trans(org)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pdfPrintNavbar',
        props: ['path_title', 'current_visit', 'craft', 'betreiber', 'org'],
        data() {
            return {

            }
        }
    }
</script>

<style lang="scss">
    .pdf-print-navbar {
        background-color: #fff;
        height: 110px;
        padding: 8px;
        box-sizing: border-box;
        .navbar-row-top {
            text-align: center;
            .image-box {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                .logo {
                    width: 40px;
                    height: auto;
                }
            }
        }
        .navbar-row-bottom {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .nav-column {
                display: flex;
                flex-direction: column;
                min-width: 70px;
                .keyName {
                    font-size: 14px;
                    font-weight: 300;
                }
                .keyvalue {
                    font-size: 14px;
                    font-weight: 400;
                    color: #1B608C;
                    min-height: 14px;
                }
            }
        }
    }    
</style>